import { render, staticRenderFns } from "./DetailRemoteRequest.vue?vue&type=template&id=5a6c2da8&scoped=true&"
import script from "./DetailRemoteRequest.vue?vue&type=script&lang=js&"
export * from "./DetailRemoteRequest.vue?vue&type=script&lang=js&"
import style0 from "./DetailRemoteRequest.vue?vue&type=style&index=0&id=5a6c2da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6c2da8",
  null
  
)

export default component.exports